import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';

const DeleteAccountPageHeaderMeta = () => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector((state) => getBaseUrl(state));
    const title = formatMessage({ id: 'deleteAccountConfirmation.title' });
    const description = formatMessage({ id: 'deleteAccountConfirmation.description' });
    const canonical = `${baseUrl}/delete-account`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default DeleteAccountPageHeaderMeta;
